import React from 'react'

function Skills() {
  return (
    <div className="Skills">
      {/* <h2></h2> */}
      <div className="skills-grid">
        <div className="skill-card">
          <img src="https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg" alt="C++ Logo" className="skill-logo" />
          <h3>C++</h3>
        </div>
        <div className="skill-card">
          <img src="https://upload.wikimedia.org/wikipedia/commons/8/87/Sql_data_base_with_logo.png" alt="SQL Logo" className="skill-logo" />
          <h3>SQL</h3>
        </div>
        <div className="skill-card">
          <img src="https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg" alt="HTML Logo" className="skill-logo" />
          <h3>HTML</h3>
        </div>
        <div className="skill-card">
          <img src="https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg" alt="CSS Logo" className="skill-logo" />
          <h3>CSS</h3>
        </div>
        <div className="skill-card">
          <img src="https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png" alt="JavaScript Logo" className="skill-logo" />
          <h3>Vanilla JavaScript</h3>
        </div>
        <div className="skill-card">
          <img src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" alt="React JS Logo" className="skill-logo" />
          <h3>React JS</h3>
        </div>
      </div>
    </div>
  );
}

export default Skills;